import React, { useMemo } from 'react';
import cls from 'clsx';
import DOMPurify from 'dompurify';
import { md } from '@link/share/vendors';
import { sanitizeMarkdown } from './MarkdownSanitize';
import styles from './markdown.module.css';

export interface IReactMarkdownProps {
  source?: string;
  className?: string;
}

function renderMarkdownToHTML(markdown: string) {
  // Sources include supplier-written API content shown to every visitor, and
  // markdown-it passes raw HTML through: strip scripts and event handlers.
  // `target` is kept for the external links the link plugin opens in a new tab.
  const renderedHTML = DOMPurify.sanitize(
    md.render(sanitizeMarkdown(markdown)),
    {
      ADD_ATTR: ['target']
    }
  );
  return { __html: renderedHTML };
}
const ReactMarkdown: React.FC<IReactMarkdownProps> = ({
  className = '',
  source = ''
}) => {
  const markup = useMemo(() => renderMarkdownToHTML(source), [source]);
  return (
    <div
      className={cls(styles.markdown, className)}
      dangerouslySetInnerHTML={markup}
    />
  );
};

export default ReactMarkdown;
